import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
	const { pathname } = useLocation();
	const navigationType = useNavigationType(); // 'POP', 'PUSH', 'REPLACE'

	useEffect(() => {
		if (navigationType === "POP") {
			// Back or forward navigation, jump instantly
			window.scrollTo(0, 0);
		} else {
			// Normal navigation, smooth scroll
			window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
		}
	}, [pathname, navigationType]);

	return null;
}
